import React, { useState } from "react";
import { Col, Modal, Nav, Row, Tab, Image, Button } from "react-bootstrap";
import icTitle from "../../../assets/images/ic-edit-modal.svg";
import Add from "../../../assets/images/ic-add.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalFooter from "../../../components/modal/ENGModalFooter";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import icNext from "../../../assets/images/ic-arrow-next.svg";
import Dots from '../../../assets/images/la-dots.svg';
import RowItem from "../../../components/card/RowItemAdmin";
import InfiniteScroll from "react-infinite-scroll-component";
import SubHeader from "./SubHeader";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { GetAwarenessModule,selectAwarenessModule } from "../../../features/learning/AwarenessSlice";
import VideoItemAdmin from "../../../components/card/VideoItemAdmin";
import TextField from "../../../components/textField/TextField";
import VideoData from "../../../components/accordion/VideoData";
import { useParams } from 'react-router-dom';

const VideoModulesEdit = ({data}:{data:any}) => 
{
  
  const params = useParams();
  const { categoryId }: any = params;

    const [modalShow, setModalShow] = useState(false);  
    const handleClose = () => setModalShow(false);
    const handleShow = () => setModalShow(true);
    const AwarenessModule = useAppSelector(selectAwarenessModule);
    const dispatch = useAppDispatch();
    const [ofset, setOfset]=useState(0);
   
    const fetchMoreData = () => {
      // a fake async api call like which sends
      // 10 more records in 1.5 secs
      
      setTimeout(() => {     
         data= AwarenessModule.concat(Array.from({ length: 10 }))
         //var ofset=1
          async function fetchLearningModuleData() {      
            let sample = await dispatch(GetAwarenessModule(ofset+1));   
            setOfset((prev) => prev + 1)  
          }
          fetchLearningModuleData();
      }, 1500);
    };
    return (
      <>
        <a
          href={
            categoryId
              ? `/video/details/${categoryId}`
              : '/videomodulesDetails'
          }
        >
          <b>
            VIEW ALL
            <span style={{ fontSize: '18px' }}>
              <Image
                src={icNext}
                style={{
                  width: '20px',
                  height: '20px',
                }}
              />
            </span>
          </b>
        </a>

        <Modal
          show={modalShow}
          onHide={handleClose}
          backdrop='static'
          size='lg'
          keyboard={false}
        >
          <ENGModalHeader icon={icTitle} title='Edit Video' />
          <ENGModalBody
            contents={
              <>
                <SubHeader />
                <VideoData />
                {/* <Row style={styles.divGrey}>
                        <Col lg={3}>                        
                        <input style={styles.checkb} type="radio" name="videobutton" required />{" "}
                         Upload Video 
                        </Col>
                        <Col lg={3}>
                        <input style={styles.checkb} type="radio" name="videobutton" required />{" "}
                           Paste Link
                        </Col>
                        <Col lg={6}>
                        <VideoData/>
                        </Col>
                    </Row> */}

                {/* <Row style={styles.divGrey}>
                    <Col lg={4} >
                    <TextField type="text" id="username" label="Title" placeholder="Enter Video Title"/>  
                    </Col>
                    <Col lg={4} >
                    <TextField type="text" id="username" label="Link" placeholder="Enter Video Link"/>                       
                    </Col>
                    <Col lg={4} >
                    <TextField type="text" id="username" label="Thumbnail" placeholder="Enter Video Thumbnail"/>     
                    
                    </Col>
                    </Row> */}
                {/* 
                    <Row style={styles.divGrey}>
                    <Col lg={12} >  
                    <Button style={styles.button}>
                    Save
                    </Button>
                    </Col>
                    </Row> */}

                <InfiniteScroll
                  dataLength={data.length}
                  next={fetchMoreData}
                  hasMore={true}
                  height={500}
                  loader={<h5>Loading...</h5>}
                >
                  <Row style={styles.divGrey}>
                    {data.map((item: any) => (
                      <VideoItemAdmin item={item} columns={6} />
                    ))}
                  </Row>
                </InfiniteScroll>
              </>
            }
          />
          <ENGModalFooter
            closeMethod={handleClose}
            type='submit'
            title='SAVE CHANGES'
          />
        </Modal>
      </>
    );
    };


      const styles: any = {
        divWhite: {
            backgroundColor: "#fffff",
            paddingTop: "20px",
             paddingLeft: "20px",
             paddingRight: "20px",
          },

          button: {
            padding: "13px 40px",
            fontFamily: "Georama-Regular",
            fontSize: "12px",
            fontWeight: 400,
            fontStretch: "normal",
            fontStyle: "normal",
            borderRadius: "0",
            backgroundColor: "#e31837",
            letterSpacing: "normal",
            border: "0px",
            float:"right"
          },

          checkb: {
            boxSizing: "border-box",            
            width: "15px",
            height: "15px",
            
          },

          divGrey: {
            backgroundColor: "#faf9f9",
            paddingTop: "20px",
            paddingLeft: "10px",
            paddingRight: "20px", 
            width: "795px",
            marginLeft: "2px",                  
            
          },

          add:{
            padding: "0px",
            fontWeight: "600",
            fontSize: "12px",
            color: "#e31837",
            fontFamily: "Georama-Regular",
            float: "right",
          },  
          
          del:{
            padding: "0px",
            fontWeight: "600",
            fontSize: "12px",
            color: "#e31837",
            fontFamily: "Georama-Regular",           
          },  
          
        tabHeading: {
          fontFamily: "Georama-Regular",
          fontSize: "14px",
          fontWeight: "500",
          color: "#6d6e71",
        },
        line: {
          height: "1px",
          margin: "0px",
          backgroundColor: "#f4f4f4",
        },
        colBorder: {
            border: "solid 1px #e4e4e4",
        },
        colBorder1: {
          border: "solid 1px #e4e4e4",
          height: "100%",
      },
        text1: {
            fontFamily: "Georama-Regular",
            fontSize: "16px",
            fontWeight: "normal",
            border: "solid 1px #e4e4e4",
            borderTop: "0px",
            borderLeft: "0px",
            borderRight: "0px",
            color: "#6d6e71",
            textAlign: "center",
          },
          heading: {
              fontFamily: "Saira",
              fontSize: "12px",
              fontWeight: "500",
              color: "#6d6e71",
          },
          data: {
              fontFamily: "Georama-Regular",
              fontSize: "16px",
              fontWeight: "500",
              color: "black",
          },
          link: {
              fontFamily: "Georama-Regular",
              fontSize: "12px",
              fontWeight: "600",
              color: "#e31837",
              lineHeight: "2",
              textTransform: "uppercase",
              textDecoration: "none",
          },
};

export default VideoModulesEdit